export default __webpack_public_path__ + "static/media/avatar.94ecd351.png";